const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/labReports/loadLabSingleRepRightsHandlers.ts';
import Imm from 'immutable';
import { IKisApiHandlersMap } from '../../defs/actionTypes';
import { LoadLabSingleRepRightsAction } from '../../actions/labReportsActions';
import { Logger } from '../../services/KisLoggerService';

const Log = Logger('labReports/loadLabSingleRepRights');

export const loadLabSingleRepRightsHandlers: IKisApiHandlersMap<LoadLabSingleRepRightsAction> = {
    pending: (state, action) => {
        const repId = `${action.meta.sender}_${action.meta.reportnr}`;
        return state.setIn(['rights', repId], Imm.fromJS({ loading: 'pending' }));
    },
    success: (state, action) => {
        const repId = `${action.meta.sender}_${action.meta.reportnr}`;
        state = state.setIn(['rights', repId], Imm.fromJS(action.payload));
        return state.deleteIn(['rights', repId, 'loading']);
    },
    failure: (state, action) => {
        Log.warn('Failed to load rights of lab single report!', action);
        const repId = `${action.meta.sender}_${action.meta.reportnr}`;
        return state.setIn(['rights', repId, 'loading'], 'failure');
    },
};
